import { IStyle } from '@fluentui/react';

export interface IBarChartStyles {
  root: IStyle;
}

export interface IBarChartClassNames {
  root: string;
}

export const barChartStylesDefault: Partial<IBarChartStyles> = {
  root: {
    height: '100%',
  },
};
